import React, { useMemo } from "react";
import { Card, CardBody } from "reactstrap";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";

const ReformUpcomingEvents = ({ event }) => {
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("tr-TR", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString("tr-TR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const startDate = formatDate(event.start);
  const endDate = event.end ? formatDate(event.end) : null;
  const startTime = formatTime(event.start);
  const endTime = event.end ? formatTime(event.end) : null;

  const dateString = endDate && endDate !== startDate ? `${startDate} - ${endDate}` : startDate;
  const timeString = endTime && endTime !== startTime ? `${startTime} - ${endTime}` : startTime;

  return (
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex mb-3">
          <div className="flex-grow-1">
            <i className={`mdi mdi-checkbox-blank-circle me-2 text-${event.className.split('-')[1]}`}></i>
            <span className="fw-medium">{dateString}</span>
          </div>
          <div className="flex-shrink-0">
            <small className="badge bg-primary-subtle text-primary ms-auto">
              {timeString}
            </small>
          </div>
        </div>
        <h6 className="card-title fs-16">{event.title}</h6>
        <p className="text-muted text-truncate-two-lines mb-0">
          {event.description || "Açıklama bulunmuyor"}
        </p>
      </CardBody>
    </Card>
  );
};

const UpcomingEvents = ({ events }) => {
  const upcomingEvents = useMemo(() => {
    const now = new Date();
    return events
      .filter(event => new Date(event.start) >= now)
      .sort((a, b) => new Date(a.start) - new Date(b.start))
      .slice(0, 10); // Show only next 10 upcoming events
  }, [events]);

  return (
    <SimpleBar className="pe-2 me-n1 mb-3" style={{ maxHeight: "400px" }}>
      <div id="upcoming-event-list">
        {upcomingEvents.length > 0 ? (
          upcomingEvents.map((event, index) => (
            <ReformUpcomingEvents key={index} event={event} />
          ))
        ) : (
          <Card className="mb-3">
            <CardBody>
              <p className="text-muted mb-0">Yaklaşan etkinlik bulunmuyor</p>
            </CardBody>
          </Card>
        )}
      </div>
    </SimpleBar>
  );
};

ReformUpcomingEvents.propTypes = {
  event: PropTypes.shape({
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    className: PropTypes.string.isRequired,
  }).isRequired,
};

UpcomingEvents.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
      end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      className: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default UpcomingEvents;